export const trackingEvents = {
  PAGE: {
    VIEWED: 'worker_strikes_new.page.viewed',
  },
  SAVE_BUTTON: {
    CLICKED: 'worker_strikes_new.save_button.clicked',
  },
}
